module.exports = __webpack_public_path__ + "static/media/leaf_left_cutted.8c1e8336.png";